export const CSV_UPLOAD_ERROR_MESSAGES = {
  'admin.create.internal_admin.credential-creation-claim-exists':
    'This user already exists.',
  'allocations_permitted.invalid-allocations-permitted-specify-yes-no':
    'Invalid value allocation permitted. Enter Yes or NO.',
  'allocations permitted.invalid-allocations-permitted-specify-yes-no':
    'Invalid value allocation permitted. Enter Yes or NO.',
  'corp-id.invalid': 'Company ID does not match this organization',
  'corp-id.not_found': 'Company ID is invalid',
  'corp-id.required': 'Company ID is required',
  'delete.invalid': 'Only "Yes" may be used to delete an employee',
  'diner-file-record.unprocessable':
    'This row can not be processed, please check format and try again',
  'diners-file.exceeded-max-rows':
    'The maximum number of people you can include in a CSV file is 4,000. If you need to add more people, you can add them manually.',
  'diners-file.exceeded-max-size':
    'Your file exceeds the maximum size allowed (10 MB)',
  'diners-file.exceeded-max-diner-size':
    'Your file exceeds the maximum diner creations allowed.',
  'diners-file.exceeded-max-diner-deletion':
    'Your file exceeds the maximum diner deletions allowed.',
  'diners-file.not_found': 'Uploaded file cannot be found',
  'email.invalid': 'Email format is not valid',
  'email.not_found': 'The employee was not found',
  'email.required': 'Email is required',
  'end.invoice-to-generate-start-not-before-end':
    'Please select a valid date range.',
  'file.exceeded-max-rows':
    'The maximum number of people you can include in a CSV file is 4,000. If you need to add more people, you can add them manually.',
  'file.exceeded-max-size':
    'Your file exceeds the maximum size allowed (10 MB)',
  'file.not_found': 'Uploaded file cannot be found',
  'first-name.max-characters-exceeded':
    'First name must be 30 characters or less',
  'first-name.required': 'First name is required',
  'first name.max-characters-exceeded':
    'First name must be 30 characters or less',
  'first name.required': 'First name is required',
  'last-name.max-characters-exceeded':
    'Last name must be 30 characters or less',
  'last-name.required': 'Last name is required',
  'last name.required': 'Last name is required',
  'last name.max-characters-exceeded':
    'Last name must be 30 characters or less',
  'phone-number.invalid': 'Phone number is invalid',
  'phone number.invalid': 'Phone number is invalid',
  'request_id.diner-upload-request-already-in-progress-for-corp':
    'Another upload request is already in progress.',
  'file record.invalid': 'File record is invalid',
  'diners-file.cannot-parse-file':
    'File cannot be processed. Please ensure the file format is .csv and that it follows template guidelines.',
  'group.required': 'Group is required',
  'group.not_found': "Group doesn't exist",
  'employee-id.max-characters-exceeded':
    'Employee ID must be 30 characters or less',
  'employee id.max-characters-exceeded':
    'Employee ID must be 30 characters or less',
  'location-id.invalid': 'Location ID is invalid',
  'location-id.not_found': "This location ID doesn't exist",
  'location-id.required': 'Location ID is required',
  'location.invalid': 'Location is invalid',
  'location.not_found': "This location doesn't exist",
  'location.required': 'Location is required',
  'sso identifier.required': 'SSO Identifier is required',
  'role.invalid': 'Employee must be CORP_DINER or CORP_ADMIN',
  'role.required': 'Employee role is required',
  'group-id.invalid': 'Group ID is invalid',
  'group-id.not_found': 'Group not found',
  'group-budgets.not_found': 'Ordering permission not found',
  'group-budgets.invalid':
    'The budget is greater than the max allowed (currently $10K).',
  'department-id.invalid': 'Department ID is invalid',
  'department-id.not_found': "Department ID doesn't exist",
  'department-id.required': 'Department ID is required',
  'department.invalid': 'Department is invalid',
  'department.not_found': "Department doesn't exist",
  'department.required': 'Department is required',
};
